// @ts-nocheck
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { css } from "styled-components";

export const storeLogoStyles = () => {
    return css`
        img {
            height: 36px;
            max-width: 150px;

            ${breakpoint("sm")} {
                max-width: none;
            }

            ${breakpoint("md")} {
                height: 50px;
                width: auto;
                margin: 0;
            }

            ${breakpoint("xl")} {
                height: 58px;
            }
        }
    `;
};
